export default class ResponseError {
  constructor(code, body) {
    this.code = code
    this.body = body
  }
}
